import * as React from 'react';
import axios from 'axios';
import * as turf from '@turf/helpers';

import DeckGL from '@deck.gl/react/typed';
import {HeatmapLayer} from '@deck.gl/aggregation-layers/typed';
import { ColumnLayer, TextLayer } from '@deck.gl/layers/typed';
import { Layer, Map, Source, ViewStateChangeEvent } from 'react-map-gl';
import { App } from '../../App';
import { AuthContext } from '../../AuthContext';
import { MapControls } from '../../maps/MapControls/MapControls';
import { MarkersCircleLayer, MarkersStrokeLayer } from '../../maps/Layers';
import { DeckGLOverlay } from './DeckGLOverlay';

interface IValue {
  v: number;
  lat: number;
  lng: number;
}

const ParameterMap = () => {
  const auth = React.useContext(AuthContext);
  const [results, setResults] = React.useState([] as IValue[]);

  // Assume "Water temperature".
  React.useEffect(() => {
    axios.get(
      `${App.config.apiURL}map/1434?access_token=${auth.access_token}`)
    .then((response) => {
      setResults(response.data);
    })
  }, []);

  const [viewState, setViewState] = React.useState({
    longitude: 34.25,
    latitude: -0.3,
    zoom: 8,
    bearing: 0,
    pitch: 0,
    padding: { top: 0, bottom: 0, left: 0, right: 0 }    
  });  

  const handleMove = (e: ViewStateChangeEvent) => {
    setViewState(e.viewState);
  }

  const getGeoJSON = () => {
    return turf.featureCollection(results.map(result => {
      const p = turf.point([result.lng, result.lat]);
      p.properties.value = result.v;
      return p;
    }));
  }

  const layers = [
    /* new TextLayer({
      data: results,
      getPosition: (r: IValue) => [r.lng, r.lat, 250],
      getText: (r: IValue) => Math.round(r.v).toString(),
      getSize: 20
    }), */
    new HeatmapLayer({ 
      id: 'heatmap-layer',
      //beforeId: "markers-circles",
      data: results,
      getPosition: (r: IValue) => [r.lng, r.lat],
      getWeight: (r: IValue) => r.v
    }),
    /* new ColumnLayer({
      id: 'column-layer',
      data: results,
      getPosition: (r: IValue) => [r.lng, r.lat],
      getFillColor: r => [128, 48, (r.v - 18) / 14 * 255, 255],
      getLineColor: [0, 0, 0],      
      getElevation: (r: IValue) => r.v - 15,
      elevationScale: 600
    }) */
  ]

  return (
    <Map
      {...viewState}
      mapboxAccessToken={App.config.mapboxKey}
      style={{width: '100%', height: '100%'}}
      logoPosition="bottom-left"  // Moves mapbox logo
      fadeDuration={0}            // Prevents fading in of cluster labels
      interactiveLayerIds={[]}
      mapStyle="mapbox://styles/longlineenvironment/cl8x4af5v003n14ld74f6ugwd"
      minZoom={1}
      maxZoom={20}
      doubleClickZoom={false}
      //Events
      onMove={handleMove}      
    >
      <MapControls {...viewState}/>

      <DeckGLOverlay interleaved layers={layers}/>

      {/* <Source id="markers" type="geojson" data={getGeoJSON()}/>
        <Layer source="markers" {...MarkersCircleLayer}/>
       <Layer source="markers" {...MarkersStrokeLayer}/> */}
    </Map>
  );


}

export { ParameterMap }
